export enum ButtonLabelVisibility {
    Default = "default",
    S = "s",
    M = "m",
    L = "l",
    XL = "xl"
}
